export const SET_OWNED_DATASPACES = 'SET_OWNED_DATASPACES';
export const SET_PARTICIPANT_DET = 'SET_PARTICIPANT_DET';
export const SET_SERVICE_OVERVIEW = 'SET_SERVICE_OVERVIEW';
export const SET_DISPLAY_DETAILS = 'SET_DISPLAY_DETAILS';
export const SET_ALLOCATE_CONNECTOR_ORIGIN_DETAILS = 'SET_ALLOCATE_CONNECTOR_ORIGIN_DETAILS';
export const SET_APPLICATION_DATA = 'SET_APPLICATION_DATA';
